import { render, staticRenderFns } from "./InquiryDetailPrint.vue?vue&type=template&id=a454f44c&scoped=true&"
import script from "./InquiryDetailPrint.vue?vue&type=script&lang=js&"
export * from "./InquiryDetailPrint.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetailPrint.vue?vue&type=style&index=0&id=a454f44c&lang=scss&scoped=true&"
import style1 from "./InquiryDetailPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a454f44c",
  null
  
)

export default component.exports